<script>
import options from "./Basket.options";
export default options;
</script>

<template>
  <section class="kb-basket">
    <h1 class="kb-basket__title">{{ getLabel("cartTitle") }}</h1>

    <template v-if="cartIsEmpty">
      <div
        class="kb-basket__cards-wrapper kb-basket__cards-wrapper--empty-basket"
      >
        <h3>{{ getLabel("cartIsEmptyText") }}</h3>
        <a
          class="kb-button kb-button--full-color-spot"
          :href="getLabel('cartIsEmptyLinkHref')"
          >{{ getLabel("cartIsEmptyLinkText") }}</a
        >
      </div>
    </template>

    <div class="kb-basket__content-wrapper">
      <div class="kb-basket__cards-wrapper">
        <ul class="kb-basket__cards-list">
          <template v-for="card in basketCards" :key="card.data.productNumber">
            <li class="kb-basket__cards-list-item">
              <BasketCard
                :data="card.data"
                :variantData="card.variantData"
                :soldOut="card.soldOut"
                :alreadyRemoved="card.alreadyRemoved"
                v-on:removeItem="removeItem"
                v-on:cancelRemoveItem="cancelRemoveItem"
                :readOnlyAmount="readOnlyAmount"
              />
            </li>
          </template>
        </ul>
      </div>
      <template v-if="basketCards && basketCards.length">
        <div class="kb-basket__aside-wrapper">
          <BasketAside :miniBasket="false" :showPaymentOptions="false" />
        </div>
      </template>
    </div>
  </section>
</template>
